import { SimpleEventDispatcher } from 'ste-simple-events';

export interface ArticleContextValue {
  articleId: number | null;
  branchIds: number[];
  variantId: number | null;
}

const initialValue: ArticleContextValue = {
  articleId: null,
  branchIds: [],
  variantId: null,
};

const contextChanged = new SimpleEventDispatcher<ArticleContextValue>();
let current = initialValue;

export const articleContextEvents = {
  get current() {
    return current;
  },
  get contextChanged() {
    return contextChanged;
  },
  dispatch(value: ArticleContextValue) {
    current = value;
    contextChanged.dispatch(value);
  },
};
